const initialState: any = {
  select: ''
};

export const SELECT_COIN: string = 'COIN/SELECT_COIN'; 

type UserAction = any;

function coinReducer(state: any = initialState, action: UserAction) {
  switch (action.type) {
    case SELECT_COIN:
      let { select } = action.payload
      return {
        ...state,
        select
      };
    
    default:
      return state;
  }
}

export default coinReducer;
